module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.linkTag, _vm._b({
    tag: "component",
    class: [
      "link",
      {
        'link--anchor': _vm.linkType === "anchor",
        'link--external': _vm.linkType === "a",
        'link--internal': _vm.linkType === "router-link",
        'link--no-underline': _vm.noUnderline,
      } ],
    on: {
      "click": _vm.onClick
    }
  }, 'component', _vm.linkProps, false), [(_vm.label) ? _c('span', {
    staticClass: "link__label",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _c('span', {
    staticClass: "link__label"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aadab054"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Link.vue
// module id = 24
// module chunks = 1